document.addEventListener("DOMContentLoaded", function () {
  var click_icons = document.querySelectorAll(
    ".colorModel-wrapper.main .chooseColor"
  );
  var addButton = document.querySelector(".colorModel-wrapper.main a.button");
  var popup = document.querySelector("#nailsoverlay");

  if (!popup) return;

  click_icons.forEach(function (icon) {
    icon.addEventListener("click", function () {
      popup.dataset.index = this.dataset.index;
      popup.classList.remove("hidden");
    });
  });

  if (addButton) {
    addButton.addEventListener("click", function () {
      popup.dataset.index = this.dataset.index;
      popup.classList.remove("hidden");
    });
  }

  var closeBtn = document.querySelector(".right-svg.close");
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      var btn = document.querySelector(
        ".template--product-starterset product-payment-container #AddToCart," +
        ".template--product-starterset product-sticky-form #StickyAddToCart," +
        ".template--product-special-bundle product-payment-container #AddToCart," +
        ".template--product-special-bundle product-sticky-form #StickyAddToCart," +
        ".template--product-starterset-special-bundle product-payment-container #AddToCart," +
        ".template--product-starterset-special-bundle product-sticky-form #StickyAddToCart," +
        ".template--product-starterset-special-big-bundle product-payment-container #AddToCart," +
        ".template--product-starterset-special-big-bundle product-sticky-form #StickyAddToCart"
      );
      if (btn) {
        btn.click();
      }
      setTimeout(function () {
        popup.classList.add("hidden");
      }, 1000);
    });
  }

  var dismissBtn = document.querySelector(".nails-close-btn");
  if (dismissBtn) {
    dismissBtn.addEventListener("click", function () {
      popup.classList.add("hidden");
    });
  }
});
